import { React } from "react";
import { Container } from "react-bootstrap";
import "../css/ComingSoon.css";
/*import img_team from "../assets/img/team.png";*/
import { AiFillInstagram } from "react-icons/ai";
import { AiFillFacebook } from "react-icons/ai";
import { AiFillYoutube } from "react-icons/ai";
import { BsTiktok } from "react-icons/bs";
import { Helmet } from "react-helmet";
import { MdEmail } from "react-icons/md";
import { FaRedditAlien } from "react-icons/fa";
import logo_text from "../assets/img/logo_t4a_text_white.svg";

function About() {
  return (
    <div className="page">
      <Helmet>
        <title>thenics4all</title>
        <meta
          name="description"
          content="Step-by-step Handstand pushup progressions, training and tutorials."
        />
        <meta
          name="keywords"
          content="handstand, handstand pushup, hspu, calisthenics, progression, tutorial"
        />
      </Helmet>
      <Container fluid>
        <div className="home-row row-long">
          <h1>
            <a className="home-link" href="/about">
              About
            </a>
          </h1>
          <h2 className="home-row-subtitle">Share, inspire & be inspired</h2>
          <div className="home-about">
            <img
              className="home-logo-text-inline"
              src={logo_text}
              alt="thenics4all"
            />
            is a community project built to prove that ordinary people can unlock “impossible” goals through discipline and consistency. It started as friends challenging each other to achieve the handstand push-up. When we realized the journey can take years, we built a community project where people at every stage can track progress, share what’s working, and level up together. We welcome all feedback to help improve the program, so don’t hesitate to reach out:
            <br />
            <br />
            <div className="home-contact-icons">
              <a href="https://www.youtube.com/@thenics4all" target="_blank" rel="noopener noreferrer">
                <AiFillYoutube className="social-media-icon-home" />
              </a>
              <a href="https://www.instagram.com/thenics4all/" target="_blank" rel="noopener noreferrer">
                <AiFillInstagram className="social-media-icon-home" />
              </a>
              <a href="https://www.facebook.com/people/Thenics4all/61552753342150/" target="_blank" rel="noopener noreferrer">
                <AiFillFacebook className="social-media-icon-home" />
              </a>
              <a href="https://www.tiktok.com/@thenics4all" target="_blank" rel="noopener noreferrer">
                <BsTiktok className="social-media-icon-home" />
              </a>
              <a
                href="https://www.reddit.com/r/thenics4all/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaRedditAlien className="social-media-icon-home" />
              </a>
              <a href="mailto:info@thenics4all.com" target="_blank" rel="noopener noreferrer">
                <MdEmail className="social-media-icon-home" />
              </a>
            </div>
            {/*<div className="home-about-image">
              <div className="home-about-image-text">
                Our Team
              </div>
              <div className="pashaman">@pAshAmAn</div>
              <div className="akbar">@Silverback</div>
              <div className="zarrar">@zarrar</div>
              <img src={img_team} alt="Message" />
            </div> */}
          </div>
          <div><br></br><br></br></div>
        </div>
      </Container>
    </div>
  );
}
export default About;
